module.exports = __webpack_public_path__ + "static/media/kalakiev.54621aec.jpg";